<template>
	<ion-button
		:disabled="disabled"
		:expand="expand"
		:fill="fill"
		:color="color"
		@click="onClick"
	>
		<ion-spinner
			v-if="loading"
			slot="start"
			name="crescent"
			class="mr-2 h-[1em] w-[1em]"
		/>
		<slot />
	</ion-button>
</template>

<script lang="ts" setup>
	import { IonButton, IonSpinner } from "@ionic/vue";

	defineProps<{
		expand?: "block" | "full";
		fill?: "clear" | "outline" | "solid" | "default";
		color?: string;
		loading?: boolean;
		disabled?: boolean;
		onClick?: () => void;
	}>();
</script>
